import { nowdoApi } from "./rtk-query-api";
import { User } from "~/generated/rtk-query/nowdo-live-api.generated";

export function useUserProfile(userId: string | null) {
  const profileState = nowdoApi.useGetUserQuery({ id: userId || "" }, { skip: !userId });

  function getUser(): (User & { fullName: string; isAdult: boolean }) | null {
    const maybeUser = profileState.data;
    if (!userId || !maybeUser || maybeUser.id !== userId) {
      return null;
    }
    return {
      ...maybeUser,
      fullName: maybeUser.name,
      isAdult: !maybeUser.isStudentAge,
    };
  }

  const profile = getUser();
  return [profile, profileState] as const;
}
